import React from 'react';
import { Route, withRouter } from 'react-router';
import PropTypes from 'prop-types';
import Login from '../views/Login';
import Home from '../views/Home';
import AddUser from '../views/AddUser';
import CategoryList from '../views/Categories';
import UserList from '../views/UserList';
import ProductDetail from '../views/ProductDetail';
import UserDetail from '../views/UserDetail';
import Header from '../components/layout/Header';
import SideBar from '../components/layout/sidebar/SideBar';
import ProductSortable from '../views/ProductSortable';
import PrivateRoute from '../components/PrivateRoute';
import AdminRoute from '../components/AdminRoute';
import ColorSettings from '../views/ThemeSettings';
import Portion from '../views/Portion';
import TagGroup from '../views/TagGroup';
import Tag from '../views/Tag';
import BannerAds from '../views/BannerAds';
import HomeAds from '../views/HomeAds';
import Tablets from '../views/Tablets';
import TabletDetail from '../views/TabletDetail';
import CategoryDetail from '../views/CategoryDetail';
import Settings from '../views/Settings';
import Languages from '../views/Languages';
import LanguageDetail from '../views/LanguageDetail';


const Routes = ({ history }) => (
  <div>
    <Route path="/login" component={Login} />
    {
      history.location.pathname !== '/login' ? (
        <div>
          <SideBar />
          <Header />
        </div>
      ) : ''
    }
    <PrivateRoute exact path="/" component={Home} />
    <PrivateRoute exact path="/panel" component={Home} />
    <AdminRoute path="/panel/add-user" component={AddUser} />
    <AdminRoute path="/panel/user-list" component={UserList} />
    <PrivateRoute path="/panel/menu-edit" component={CategoryList} />
    <PrivateRoute path="/panel/product/:productId" component={ProductDetail} />
    <AdminRoute path="/panel/user/:userId" component={UserDetail} />
    <PrivateRoute path="/panel/product-sorting" component={ProductSortable} />
    <PrivateRoute path="/panel/color-settings" component={ColorSettings} />
    <AdminRoute path="/panel/portion/:portionId" component={Portion} />
    <AdminRoute path="/panel/tag-group/:tagGroupId" component={TagGroup} />
    <AdminRoute path="/panel/tag/:tagId" component={Tag} />
    <AdminRoute path="/panel/tablets" component={Tablets} />
    <AdminRoute path="/panel/tablet/:tabletId" component={TabletDetail} />
    <AdminRoute path="/panel/category/:categoryId" component={CategoryDetail} />
    <AdminRoute path="/panel/banner-ads" component={BannerAds} />
    <AdminRoute path="/panel/home-ads" component={HomeAds} />
    <AdminRoute path="/panel/settings" component={Settings} />
    <AdminRoute path="/panel/languages" component={Languages} />
    <AdminRoute path="/panel/langs/:language" component={LanguageDetail} />

  </div>
);
Routes.propTypes = {
  history: PropTypes.shape({
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }),
  }).isRequired,
};
export default withRouter(Routes);
